export class TableContextKindEdit {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "value",
            "baseName": "value",
            "type": "string",
            "format": ""
        },
        {
            "name": "note",
            "baseName": "note",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return TableContextKindEdit.attributeTypeMap;
    }
    constructor() {
    }
}
